import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { SmsGatewayProviderCreateRequest, SmsGatewayProviderResponse, SmsGatewayProviderUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { SmsGatewayDetailsSectionHandler } from './details.section';
import { SmsGatewayParametersSectionHandler } from './parameters.section';
import { HealthIssueService } from '../healthissues/healthissue.service';
import { DomSanitizer } from '@angular/platform-browser';

@RegisterEntityHandler('smsgatewayprovider')
@Injectable()
export class SmsGatewayProviderHandler extends EntityHandler<SmsGatewayProviderResponse> {

    constructor(
        admin: AdminEditorService,
        private issues: HealthIssueService,
        private sanitizer: DomSanitizer
    ) {
        super(admin);
    }

    states = ['active', 'suspended', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listSmsGatewayProviders/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listSmsGatewayProviders(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'smsgatewayprovider',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.SMSGATEWAYPROVIDER'),
        }));
    }

    getEntity(id: string): Promise<SmsGatewayProviderResponse> {
        return this.admin.getCached(`getSmsGatewayProvider/${id}`, api => api.entities.getSmsGatewayProvider(id), 10);
    }

    async createEntity(ownerId: string, entity: SmsGatewayProviderCreateRequest): Promise<SmsGatewayProviderResponse> {
        const smsGatewayProviderType = await this.admin.getCached(`getSmsGatewayProviderType/${entity.type.id}`, api => api.entities.getSmsGatewayProviderType(entity.type.id));
        entity.ownerId = ownerId;
        entity.direction = smsGatewayProviderType.direction;
        return this.admin.applyUpdate(api => api.entities.createSmsGatewayProvider(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateSmsGatewayProvider(entity.id, { state: state as any }));
    }

    async getGridColumns(ownerId: string): Promise<IKuiTableCol[]> {
        const types = await this.admin.getCached(`listSmsGatewayProviderTypes/${ownerId}/0/100/name/null`, api => api.entities.listSmsGatewayProviderTypes(ownerId, 0, 100, 'name', null));
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.SMSGATEWAYPROVIDER.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', ICONS.smsgateway),
            grid.IdNameComboColumn('type', 'TYPE', types.items.map(x => ({ id: x.id, value: x.name })), 100),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    async getEditorSections(ownerId: string, entity: any): Promise<SectionHandlerGroup<SmsGatewayProviderResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new SmsGatewayDetailsSectionHandler(this.admin, ownerId, false),
                new SmsGatewayParametersSectionHandler(this.admin, ownerId, false),
            ],
            warnings: entity ? (await this.issues.getIssuesForEntity(ownerId, entity.id, 1)).map(issue => {
                return this.sanitizer.bypassSecurityTrustHtml(`${issue.description}<br><a href="/#/admin/client/${entity.owner.id}/healthissues/grid/healthissue/${issue.id}">More</a>`);
            }) : [],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: SmsGatewayProviderUpdateRequest, sections: FormSectionHandler<SmsGatewayProviderResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'smsgatewayprovider',
            entity: {}, // set up some defaults if you want
            sections: [
                new SmsGatewayDetailsSectionHandler(this.admin, ownerId, true),
                new SmsGatewayParametersSectionHandler(this.admin, ownerId, true),
            ],
        });
    }

}












